import { FinalCalculation } from '~/Api/User/ProductGroup/LtMaxPrice/FinalCalculation';
import { mapCalculationPrice, RawCalculationPrice } from '~/Api/User/ProductGroup/LtMaxPrice/mapCalculationPrice';
import { mapReferencedProduct, RawReferencedProduct } from '~/Api/User/ProductGroup/LtMaxPrice/mapReferencedProduct';
import { ApiClientError } from '~/ApiClient';

import { mapError } from './mapError';

export interface RawFinalCalculation {
	emptyResultReason: ApiClientError[];
	gesvisPrice: RawCalculationPrice | null;
	priceDropPercents: number | null;
	referencedProduct: RawReferencedProduct | null;
}

export const mapFinalCalculation = (finalCalculation: RawFinalCalculation): FinalCalculation => {
	const { emptyResultReason, gesvisPrice, priceDropPercents, referencedProduct } = finalCalculation;

	return new FinalCalculation(
		emptyResultReason.map(mapError),
		gesvisPrice !== null ? mapCalculationPrice(gesvisPrice) : null,
		priceDropPercents,
		referencedProduct !== null ? mapReferencedProduct(referencedProduct) : null
	);
};
